
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EndpointBase } from './endpoint-base.service';
import { AuthService } from './auth.service';
import { ConfigurationService } from './configuration.service';

export interface TableauEmbedResponse {
    token: string;
    vizUrl: string;
}

@Injectable({
    providedIn: 'root'
})
export class TableauService extends EndpointBase {
    private readonly apiUrl: string;

    constructor(
        configurations: ConfigurationService,
        http: HttpClient,
        authService: AuthService
    ) {
        super(http, authService);
        this.apiUrl = configurations.baseUrl + '/api/tableau';
        this.authServiceForTableau = authService;
    }

    private readonly authServiceForTableau: AuthService;

    getEmbedToken(): Observable<TableauEmbedResponse> {
        const accessToken = this.authServiceForTableau.accessToken;

        if (!accessToken) {
            throw new Error(
                'Bridge access token is missing. Please sign in again.'
            );
        }

        const headers = new HttpHeaders({
            Authorization: `Bearer ${accessToken}`
        });

        return this.http.get<TableauEmbedResponse>(
            `${this.apiUrl}/token`,
            { headers }
        );
    }
}
